import Repository from './Repository';

import store from "../store";
let currentUser = '';
let userType = '';
let resource = '';


function getApi() {
  currentUser = store.getters.currentUser;
  userType = "admin";
  resource = "/auth/v1/admin/credentials";
  if (
    currentUser.role == "MERCHANT_ADMIN" ||
    currentUser.role == "MERCHANT_USER"
  ) {
    userType = "merchchant";
    resource = "/auth/v1/merchants/credentials";
  }
}


export default {
  getAllCredentialsKeyValues(paymentModeCode) {
    getApi();
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/keys/${paymentModeCode}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  getModeCredentialKeyValue(merchantId, paymentModeID) {
    getApi();
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/${merchantId}/${paymentModeID}/keys`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  createPaymentModeWiseCredentials(merchantId, modeId, payload) {
    getApi();
    return new Promise((resolve, reject) => {
      Repository.post(`${resource}/${merchantId}/${modeId}`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  updatePaymentModeWiseCredentials(merchantId, paymentModeId, payload) {
    const params = {
      merchantId: merchantId,
      paymentModeId: paymentModeId
    }
    getApi();
    return new Promise((resolve,reject) => {
      Repository.post(`${resource}/merchant-payment-credentials/update`,payload,{params:params})
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error.response);
      })
    })
  }
}
